<div class="table-responsive">
  <table class="table table-nowrap mb-0">
    <!-- <colgroup appColEvenly [cols]="showAccount ? 11 : 10"></colgroup> -->
    <thead>
      <tr>
        <th *ngIf="showAccount">Account</th>
        <th>Time</th>
        <th>Market</th>
        <th>Action</th>
        <th>Side</th>
        <th class="text-end">Positions</th>
        <th class="text-end">Avg. Price</th>
        <th class="text-end">Size</th>
        <th class="text-end">Premium</th>
        <th class="text-end">Fee</th>
        <th class="text-end">Gas Fee</th>
        <th class="text-end">PNL</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let trade of trades">
        <td class="align-middle" *ngIf="showAccount">
          <app-address [address]="trade.account" [category]="trade.category" [note]="trade.note"></app-address>
        </td>
        <td class="align-middle">
          <a [href]="ethWalletService.getTxUrl(trade.txHash)" target="_blank" rel="noopener">{{
            trade.timestamp * 1000 | date : 'MMM dd, y, HH:mm'
          }}</a>
        </td>
        <td class="align-middle">
          <div class="d-flex align-items-center">
            <img class="me-2" [src]="'/retired-zksync/assets/images/' + trade.marketName.split('-')[0].toLocaleLowerCase() + '.svg'" />{{ trade.marketName }}
          </div>
        </td>
        <td class="align-middle">
          <span [translate]="'trade.type.' + trade.changeType"></span>
        </td>
        <td class="align-middle">{{ trade.size.gte(0) ? 'Buy' : 'Sell' }}</td>
        <td class="align-middle text-end">
          <div class="text-white">$<ngx-money [value]="trade.strike" [precision]="0" [disableTooltip]="true"></ngx-money>-{{ trade.isCall ? 'Call' : 'Put' }}</div>
          <div class="fs-7">{{ trade.expiry * 1000 | date : 'MMM dd y, h a' }}</div>
        </td>
        <td class="align-middle text-end">$<ngx-money [value]="trade.avg" [precision]="2"></ngx-money></td>
        <td
          class="align-middle text-end"
          [class.text-success]="trade.size.gte(0)"
          [class.text-danger]="trade.size.lt(0)"
        >
          <ngx-money [value]="trade.size" [precision]="2" [signed]="true"></ngx-money>
        </td>
        <td class="align-middle text-end">
          <ngx-money
            [class.text-success]="trade.premium.gt(0)"
            [class.text-danger]="trade.premium.lt(0)"
            [value]="trade.premium"
            [precision]="2"
            [signed]="true"
            symbol="$"
          ></ngx-money>
        </td>
        <td class="align-middle text-end">
          <ngx-money
            [class.text-success]="trade.fee.gt(0)"
            [class.text-danger]="trade.fee.lt(0)"
            [value]="trade.fee"
            [precision]="2"
            [signed]="true"
            symbol="$"
          ></ngx-money>
        </td>
        <td class="align-middle text-end">
          <ngx-money
            [class.text-success]="trade.gasFee.gt(0)"
            [class.text-danger]="trade.gasFee.lt(0)"
            [value]="trade.gasFee"
            [precision]="2"
            [signed]="true"
            symbol="$"
          ></ngx-money>
        </td>
        <td class="align-middle text-end">
          <ngx-money
            [class.text-success]="trade.realized.gt(0)"
            [class.text-danger]="trade.realized.lt(0)"
            [value]="trade.realized"
            [precision]="2"
            [signed]="true"
            symbol="$"
          ></ngx-money>
        </td>
      </tr>
    </tbody>
  </table>
</div>
